import React from 'react';
import Icon from '../components/Icon';
import PageHead from '../components/PageHead';
import { EMERGENCY_NUMBER, VIOLETA_LINES, VIOLETA_LINES_HOURS } from '../config/site';
import { usePageMeta } from '../hooks/usePageMeta';

// The numbers are the ones in the app's helplines screen (4.2.7). On 7 Oct 2026 Tinta Violeta decided to keep
// only its own 4 lines plus 911: the other official numbers did not answer. The hours are the ones Tinta
// Violeta confirmed on 13 Oct 2026; no services are claimed (fact-check A6).
const Help: React.FC = () => {
  usePageMeta(
    'Líneas de ayuda · Violeta',
    'Números de emergencia y de ayuda en Venezuela: 911 y las líneas de Violeta. Toca un número para llamar.',
  );

  return (
    <>
      <PageHead title="Líneas de ayuda" crumb="Líneas de ayuda" lead="Toca un número para llamar desde tu teléfono." />

      <div className="page-body">
        <div className="container stack">
          <section className="big-911" aria-labelledby="emergencia">
            <h2 id="emergencia">¿En peligro ahora?</h2>
            <a className="btn btn--light btn--lg" href={`tel:${EMERGENCY_NUMBER}`}>
              <Icon name="phone" />
              Llamar al {EMERGENCY_NUMBER}
            </a>
          </section>

          <section aria-labelledby="violeta" className="stack">
            <h2 className="section-title" id="violeta">Líneas de Violeta</h2>
            <div className="notice" role="note">
              <Icon name="timer" />
              <p>
                <strong>Atienden {VIOLETA_LINES_HOURS}</strong> Fuera de ese horario, llama al{' '}
                <a href={`tel:${EMERGENCY_NUMBER}`}>{EMERGENCY_NUMBER}</a>.
              </p>
            </div>
            <p className="muted">Son las líneas de apoyo que aparecen en la app. Si una no contesta, prueba con otra.</p>
            <ul className="lines">
              {VIOLETA_LINES.map((line) => (
                <li key={line.tel}>
                  <a className="dial dial--compact" href={`tel:${line.tel}`} aria-label={`Llamar al ${line.label}`}>
                    <b className="dial__line">{line.label}</b>
                    <span className="dial__label">Línea de Violeta</span>
                    <span className="dial__go">
                      <Icon name="phone" />
                      Llamar
                    </span>
                  </a>
                </li>
              ))}
            </ul>
          </section>

          <p className="muted">
            Violeta no es un servicio de emergencias. Estos números son los mismos que aparecen en la app Violeta.
          </p>
        </div>
      </div>
    </>
  );
};

export default Help;
